import styled,  { keyframes } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const BaseAnimation = styled.div`
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
    animation-delay: 0.4s;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: both;
    animation-play-state: running;
`;

export const Wrapper = styled.div`
    width: 100%;
`;

const rightToLeftAnimation = keyframes`
    0% {
        background-position: 0 0;
    }
    75% {
        background-position: -320px 0;
        background-color: ${COLORS.BgMain};
    }
    100% {
        background-position: -320px 0;
        background-color: ${COLORS.BgSurface};
    }
`;

export const TariffsPlug = styled(BaseAnimation)<{ isWebpUsed: boolean }>`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    margin-left: 8px;
    width: 100%;
    max-width: 304px;
    height: 468px;
    ${FONTS.XS};
    text-align: center;
    white-space: pre-wrap;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgMain};
    background-image: url('/static/images/tariff-lines/bg-wave.${p => p.isWebpUsed ? 'webp' : 'png'}');
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: auto 100%;

    animation-name: ${rightToLeftAnimation};
`;

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const PlugContent = styled(BaseAnimation)`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    gap: 16px;
    white-space: pre-wrap;

    animation-delay: 2.2s;
    animation-duration: 0.5s;
    animation-name: ${fadeIn};
`;

export const SvgIcon = styled.svg`
    fill: ${COLORS.BgMain};
`;
